import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match, Wrestler } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
`;

interface BoxSinglePartecipantProps {
    countWrestler: number;
}

export const BoxSinglePartecipant = styled.div<BoxSinglePartecipantProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    // Se countWrestler è maggiore di 10, width uguale a 100%10, altrimenti diviso 5
    width: ${props => props.countWrestler > 10 ? 'calc(100% / 10)' : 'calc(100% / 5)'};
    height: 15px;

    & img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: top;
    }
`;

export const BoxWinnersRumble = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 100%;

`;

export const SingleBoxWinnerRumble = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;

    & img {
        width: 100%;
        height: 80%;
        object-fit: cover;
        object-position: top;
    }

    & h6.name-wrestler {
        font-size: 7px;
        font-weight: 500;
        margin: 0;
        padding: 0;
        width: 100%;
        height: 20%;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;

interface RumbleMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

const RumbleMatchRender: FC<RumbleMatchRenderProps> = ({ matchInfo, withWinner, isExpanded = false }) => {


    const wrestlers = matchInfo.wrestlers;
    const winners = matchInfo.winners;
    const belt = matchInfo.belt;

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard className='rumble-match-render'
            height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>
                    <WrapperSideSpace className='wrapper-side-space-rumblr'>

                        {wrestlers.map((wrestler, index) => (
                            <BoxSinglePartecipant key={index} countWrestler={wrestlers.length}>
                                <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} />
                            </BoxSinglePartecipant>
                        ))}

                    </WrapperSideSpace>
                </SideSpace>

                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Rumble' />

                <SideSpace className='side-space'>
                    <WrapperSideSpace className='wrapper-side-space-rumblr'>
                            <BoxWinnersRumble>
                            {winners.map((winner, index) => (
                                <SingleBoxWinnerRumble key={index}>
                                    <img src={process.env.REACT_APP_STORAGE_URL + winner.avatar_path} alt={winner.name} />
                                    <h6 className="name-wrestler">{winner.name}</h6>
                                </SingleBoxWinnerRumble>
                            ))}
                            </BoxWinnersRumble>
                    </WrapperSideSpace>
                </SideSpace>
            </GenericContainerCard>
        )
    }


    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default RumbleMatchRender;
